import type { ThemeWithoutTokens } from '../theme.types';

export const headerNavBarTokens = (theme: ThemeWithoutTokens) =>
  ({
    headerNavBarBorderBottom: `1px solid ${theme.colors.border}`,
    headerNavBarPaddingX: theme.space.component.x.l,
    headerNavBarLogoFontSize: '2.5rem',
    headerNavBarBurgerPaddingY: theme.space.component.y.s,
    headerNavBarBurgerPaddingX: theme.space.component.x.s,
  }) as const;
